<template>
	<div
		@click="onClick"
		@mouseenter="onHover"
		ref="menu_list_item_container"
		@mouseleave="isHovered = false"
		:class="[isSelected ? 'selected' : isHovered || isFocused ? 'focused' : '', isDisabled ? 'disabled' : '']"
		class="menu-item-container px-4 display-flex flex-row flex-justify-space-between flex-align-center"
	>
		<div class="display-flex flex-row flex-align-center">
			<div v-if="allowMultipleSelection" class="check-box flex-centerize mr-1" :class="{ selected: isSelected }">
				<v-icon v-if="isSelected" class="check-icon">mdi-check</v-icon>
			</div>
			<div class="display-flex flex-column height-100 flex-align-start">
				<div :class="{ selected: isSelected }" class="item-name">
					{{ item.option }}
				</div>
				<div v-if="!additionalInfo">
					<div :class="{ selected: isSelected }" v-if="showSubtextOnly" class="value-description">
						{{ subTextDescription }}
					</div>
					<div :class="{ selected: isSelected }" v-else-if="showValueAndSubTextDescription" class="value-description">
						{{ subTextDescription }} (value: {{ valueDescription }})
					</div>
					<div :class="{ selected: isSelected }" v-else class="value-description">
						{{ valueDescription }}
					</div>
				</div>
			</div>
		</div>

		<div v-if="additionalInfo" class="additional-info-text">
			{{ additionalInfo }}
		</div>

		<AppDropdownMenu v-if="showItemButton" left bottom absolute min-width="215" :nudge-bottom="10" :items="optionsItems">
			<template #activator="{ on }">
				<v-btn class="ml-2" v-on="on" icon small rounded width="20" height="20">
					<SIcon class="menu-button" name="menu-button" width="20" />
				</v-btn>
			</template>
		</AppDropdownMenu>
		<component v-if="isUpgradeRequired" :is="indicator" :billingFeatureId="item.required_entitlement" />
	</div>
</template>

<script>
import { useEntitlement } from '@/store/modules/billing/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import { isNullOrUndefinedOrEmpty } from '@/utils/helpers';
export default {
	name: 'ParamsListItem',
	props: {
		isUpgradeRequired: { type: Boolean, default: false },
		indicator: { type: Object },
		item: { type: Object },
		isFocused: { type: Boolean },
		isSelected: { type: Boolean },
		additionalInfo: { type: String },
		hideValueDescription: { type: Boolean },
		allowMultipleSelection: { type: Boolean },
		showItemButtonFunc: { type: Function, default: () => false },
	},
	computed: {
		...mapGettersShorthand({ useEntitlement }),
		showSubtextOnly() {
			return !isNullOrUndefinedOrEmpty(this.subTextDescription) && this.item.should_display_subtext_only;
		},
		showValueAndSubTextDescription() {
			return !isNullOrUndefinedOrEmpty(this.subTextDescription);
		},
		valueDescription() {
			return this.item.value;
		},
		subTextDescription() {
			return this.item.subText;
		},
		optionsItems() {
			return [{ text: 'Edit', onClick: () => this.$emit('item-btn-clicked', this.item) }];
		},
		showItemButton() {
			return this.showItemButtonFunc(this.item);
		},
		isDisabled() {
			return this.item.disabled;
		},
	},
	methods: {
		onClick() {
			if (this.isUpgradeRequired) {
				// Opens billing upgrade dialog
				return;
			}
			this.$emit('select-item', this.item);
		},
		onHover() {
			this.isHovered = true;
			// clear focused menu item if hovering on another
			this.$emit('focus-on-item', null);
		},
	},
	watch: {
		isFocused: {
			handler(newV) {
				newV && this.$emit('scroll-to-element', this.$refs.menu_list_item_container.getBoundingClientRect());
			},
		},
	},
	data() {
		return {
			isHovered: false,
		};
	},
};
</script>

<style scoped lang="scss">
.menu-item-container {
	min-height: 33px;
	cursor: pointer;
	font-size: 12px;
	line-height: 16px;
	background: var(--bg-color);

	&.disabled {
		opacity: 0.5;
		pointer-events: none;
	}

	&.focused {
		background: var(--insert-data-item-hover-background);
	}

	&.selected {
		background: var(--insert-data-item-selected-background);
	}

	.item-name {
		line-height: 18px;
		color: var(--primary-font-color);
		&.selected {
			color: var(--primary-color);
		}
	}
	.value-description {
		font-size: 10px;
		color: var(--insert-data-value-description);
		&.selected {
			color: var(--primary-color);
			opacity: 0.5;
		}
	}
	.additional-info-text {
		color: var(--insert-data-value-description);
	}
	.check-box {
		width: 14px;
		height: 14px;
		border-radius: 3px;
		background: var(--bg-color);
		border: 1px solid var(--primary-color);
		&.selected {
			background: var(--primary-color);
		}
		.check-icon {
			width: 8px;
			height: 6px;
			font-size: 14px;
			color: var(--bg-color);
		}
	}
}
</style>
